import React, { Fragment } from "react"
import { ImageHeader } from "../imageHeader"
import "./index.scss"

import desktopDelimiter from "../../images/delimiter_desktop.png"

export const HomepageSlide = ({ mobileImgSrc, desktopImgSrc, children, videoSrc }) => {
  return (<Fragment>
    <div className="homepage-mobile d-sm-none">
      <div className="header-image">
        {!videoSrc &&
        <ImageHeader imgSrc={mobileImgSrc}/>
        }
        {videoSrc &&
        <ImageHeader videoSrc={videoSrc}/>
        }
      </div>
      <div className="bottom-section">
        {children}
      </div>
    </div>
    <div className="homepage-desktop d-none d-sm-block">
      <section className="container-fluid p-0 slide slide1">
        <div className="row m-0">
          <div className="page-container d-flex">
            {!videoSrc &&
            <div className="desktop-left-section" style={{ backgroundImage: `url('${desktopImgSrc}')` }}>
              <div className="desktop-section-delimiter"
                   style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
            </div>
            }
            {videoSrc &&
            <div className="desktop-left-section">
              <video autoPlay="autoPlay" loop muted playsInline style={{ width: "100%", height: "100%", objectFit: "cover" }}
                     src={videoSrc}/>
              <div className="desktop-section-delimiter"
                   style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>
            </div>
            }
            <div
              className="desktop-right-section d-flex flex-column align-items-center justify-content-center">
              {children}
            </div>
          </div>
        </div>
      </section>
    </div>
  </Fragment>)

}
